import { SupportedMarketKey } from '@nxt-insurance/constants'

import type { AnyStepContentElement } from '@flows/core/types/stepContentTypes'

const inputConfiguration = {
  houseNumber: {
    type: 'input',
    name: 'houseNumber',
    label: {
      type: 'translatableText',
      translationKey: 'sharedFlows_common:steps.location.inputs.house',
    },
    disabledIfValueExists: true,
  },
  street: {
    type: 'input',
    name: 'street',
    label: {
      type: 'translatableText',
      translationKey: 'sharedFlows_common:steps.location.inputs.street',
    },
    disabledIfValueExists: true,
  },
  zip_code: {
    type: 'input',
    name: 'zip_code',
    label: {
      type: 'translatableText',
      translationKey: 'sharedFlows_common:steps.location.inputs.plz',
    },
    disabledIfValueExists: true,
  },
  town: {
    type: 'input',
    name: 'town',
    label: {
      type: 'translatableText',
      translationKey: 'sharedFlows_common:steps.location.inputs.location',
    },
    disabledIfValueExists: true,
  },
} as const

const LOCATION_INPUT_ORDER: Record<
  SupportedMarketKey,
  ('houseNumber' | 'street' | 'zip_code' | 'town')[]
> = {
  [SupportedMarketKey.De]: ['street', 'houseNumber', 'zip_code', 'town'],
  [SupportedMarketKey.At]: ['street', 'houseNumber', 'zip_code', 'town'],
}

export const getLocationStepContent = (market: SupportedMarketKey) => {
  return [
    {
      type: 'title',
      text: {
        type: 'translatableText',
        translationKey: 'sharedFlows_common:steps.location.title',
      },
    },
    ...LOCATION_INPUT_ORDER[market].map((inputKey) => inputConfiguration[inputKey]),

    {
      type: 'input',
      name: 'country',
      label: {
        type: 'translatableText',
        translationKey: 'sharedFlows_common:steps.location.inputs.country',
      },
      disabled: true,
      value: {
        type: 'translatableText',
        translationKey: `sharedFlows_common:countries.${market}`,
      },
    },
  ] as const satisfies AnyStepContentElement[]
}
export type GetLocationStepContent = ReturnType<typeof getLocationStepContent>
